import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { ChipConnector } from '~/components/AiSearchChips/ChipConnector/ChipConnector';
import { useLocaleKeys } from '~/i18n';
import { moveCollectionQuantifier, nextCollectionQuantifier, presentCollectionEntries } from './collection-predicate';
import { collectionOperatorLabel } from './CollectionConditionChip/CollectionConditionChip.utils';
import { CollectionQuantifierChips } from './CollectionQuantifierChips';
export const GetCollectionChipsTID = (parentTestId)=>getTestIds(parentTestId);
export const CollectionChips = (param)=>{
    let { testId, fieldLabel, nounLabel, collection, toggleBiName, removeBiName, biPrefix, onChange } = param;
    const { CollectionChipsTestIds } = useMemo(()=>GetCollectionChipsTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const toggleQuantifier = (quantifier)=>{
        const target = nextCollectionQuantifier(collection, quantifier);
        if (target === quantifier) return;
        onChange(moveCollectionQuantifier(collection, quantifier, target));
    };
    const sharedChipProps = {
        labels: {
            field: fieldLabel,
            noun: nounLabel
        },
        biNames: {
            toggle: toggleBiName,
            remove: removeBiName,
            prefix: biPrefix
        },
        collection,
        onChange
    };
    const quantifierTestIds = (quantifier)=>({
            chip: CollectionChipsTestIds.Chip(quantifier),
            orPill: (armIndex)=>CollectionChipsTestIds.OrPill(quantifier, armIndex),
            orPillConnector: (armIndex)=>CollectionChipsTestIds.OrPillConnector(quantifier, armIndex)
        });
    const quantifierChipProps = (quantifier, predicate)=>_object_spread_props(_object_spread({}, sharedChipProps), {
            testIds: quantifierTestIds(quantifier),
            quantifier,
            predicate,
            operator: collectionQuantifierOperator(quantifier),
            onToggleQuantifier: ()=>toggleQuantifier(quantifier)
        });
    const collectionQuantifierOperator = (quantifier)=>{
        const label = collectionOperatorLabel(quantifier, t);
        return label == null ? undefined : {
            label,
            onToggle: ()=>toggleQuantifier(quantifier),
            biName: toggleBiName
        };
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: presentCollectionEntries(collection).map((param, index)=>{
            let { quantifier, predicate } = param;
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                        testId: CollectionChipsTestIds.AndConnector(index - 1),
                        tone: "and"
                    }),
                    /*#__PURE__*/ _jsx(CollectionQuantifierChips, _object_spread({}, quantifierChipProps(quantifier, predicate)))
                ]
            }, quantifier);
        })
    });
};
